import React from 'react';
import ReportView from './components/ReportView';
import sampleReport from './sample-report.json';

// Public example of the paid report, with a fictitious business. Clearly
// labelled as such; it doubles as the reference fixture for the schema.
const ReportExample = () => <ReportView report={sampleReport} isExample />;

export default ReportExample;
